$(window).scroll(function () {
    setHeaderScroll(window.scrollY);
});


// Functions

// Sets the header scroll class to the header if the user is scrolled down 100px or more
function setHeaderScroll(scrollTop) {
    if (scrollTop < 5) {
        $('header').removeClass('scroll');
    } else {
        $('header').addClass('scroll');
    }
}

// Sets the hamburger open class to the header
function hamburgerHandler() {
    $('.js-mobile-nav-toggle').click(function () {
        $('header').toggleClass('nav-open');
    });

    $('.cart-popup__close').on('click', function () {
        $('.cart-popup-wrapper--hidden').removeClass('show');
    });

    $('.cart-popup-wrapper--hidden, .cart-popup-wrapper--hidden').on('mouseleave', function () {
        $('.cart-popup-wrapper--hidden').removeClass('show');
    });
}

// Renders the search icon in the correct place depending on screen width
function showSearchBar() {
    if (window.innerWidth < 750) {
        var code = $('#DesktopSearchContainer').html();

        $('#MobileSearchContainer').append(code);
        $('#DesktopSearchContainer').empty();
    }
}

/* FAQ aria controls */
let faqs = {
    init() {
        this.details = document.querySelectorAll('details');
        this.ariaControl();
    },
    ariaControl() {
        Array.prototype.forEach.call(this.details, detail => {
            detail.onclick = () => {
                let expanded = detail.getAttribute('aria-expanded') === 'true' || false;
                detail.setAttribute('aria-expanded', !expanded);
            }
        });
    }
}

// Swatches 
const swatches = {
    init() {
        this.addClick();
        this.widthDepended();
        $(window).on('resize', this.widthDepended);
    },
    addClick() {
        document.querySelectorAll('.toggle-swatches').forEach(swatch => {
            swatch.addEventListener('click', function (event) {
                event.preventDefault();
                let open = this.getAttribute('aria-open');
                this.setAttribute('aria-open', !open);
                this.style.display = 'none';
                this.parentElement.querySelectorAll('.swatches-list__swatch:not(.toggle-swatches)').forEach(s => {
                    s.style.display = open ? 'block' : 'none';
                })
            })
        });
    },
    widthDepended() {
        if ($(window).width() < 750) {
            document.querySelectorAll('.swatches-list').forEach(swatches_drop => {
                swatches_drop.querySelectorAll('.active').forEach(s => {
                    s.addEventListener('click', function (event) {
                        event.preventDefault();
                    });
                });
                swatches_drop.addEventListener('click', function (event) {
                    let open = this.getAttribute('aria-open');
                    this.setAttribute('aria-open', !open);
                    this.classList.add('open-dropdown');
                    swatches.createDropdown();
                });
            })

        } else {

        }
    },
    createDropdown() {
        console.log('creates drop')

    },
    destroyDropdown() { }
}

// Exterior colours slideout
const exteriorColors = {
  init() {
    this.addEventListeners();
  },
  addEventListeners () {
    const openDrawer = document.getElementById('exterior_swatch-arrow')
    const drawer = document.getElementById('slide-up-container')
    if (!drawer || !openDrawer) return;
    openDrawer.addEventListener('click', () => {
      drawer.classList.toggle('active');
      document.body.classList.add('overflow-hidden');
    });
    
    document.addEventListener('click', (event) => { 
      const drawerClicked = drawer.contains(event.target) || event.target.id === 'exterior_swatch-arrow'; 
      if(!drawerClicked) { 
        drawer.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    })
  }
}


// LOAD ALL
function readyCustom(callback) {
    if (document.readyState != 'loading') callback();
    else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
}


/*============================================================================
    Recently viewed
  ==============================================================================*/

var recentlyViewed = {
  init: function(){

    var productHandle,
        rvCookie,
        rvProducts,
        displayProducts,
        rvProductArray;

    if ($('.js-product_section[data-rv-handle]').length){
      productHandle = $('.js-product_section').data('rv-handle').toString();
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.recently-viewed__section').length){
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.js-sidebar-recently-viewed').length){
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts){
      rvProductArray = unescape(rvProducts).split(',');
    }

    if (productHandle){

      if(!$.inArray(productHandle, rvProductArray) !== -1){
        displayProducts = [];
        rvProductArray.unshift(productHandle);
        $.each(rvProductArray, function(i, el){
            if($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }

      recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray;
    }

    if ($('.recently-viewed__section').length){
      var parent = '.recently-viewed__section';
      var recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    } else if ($('.js-recently-viewed .rv-main').length){
      var parent = '.js-recently-viewed';
      var recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');

      if (recentlyViewedProductsLoaded) {
        return false;
      }

      recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }

    if ($('.sidebar .js-sidebar-recently-viewed').length){
      var parent = '.sidebar .js-sidebar-recently-viewed';
      var recentlyViewedProductsLoaded = $(parent).data('recently-viewed-items-loaded');
      if (recentlyViewedProductsLoaded) {
        return false;
      }

      if (productHandle){
        recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      } else {
        recentlyViewed.getProductInformation(parent, displayProducts);
      }
    }

  },
  getCookieProducts: function(rvCookie, productHandle){

    if (!rvCookie && productHandle) {
      Cookies.set('recentlyViewed', productHandle, { expires: 30, path: '/' });
      rvCookie = Cookies.get('recentlyViewed');
    } else {
      rvCookie = Cookies.get('recentlyViewed');
    }

    return rvCookie;

  },
  setCookieProducts: function(rvProductArray){
    Cookies.set('recentlyViewed', escape(rvProductArray.join(',')), { expires: 30, path: '/' });
  },
  getProductInformation: function(parent){
    // CHECK IF EXIST <-- 
    if(typeof this.getCookieProducts() == "undefined"){
      console.log("undefined");
    } else {
      let products = this.getCookieProducts().split("%2C");
      let recentlyViewedContainer = $(".js-recently-viewed");
      recentlyViewedContainer.attr('data-recently-viewed-items-loaded', 'true');

      if(products.length > 0){
        var limit = $(".recently-viewed-products-container").data("products-limit");
        $.each(products, function(index, value){
          recentlyViewedContainer.find($(".rv-box-" + index));
          
          $.ajax({
            type: 'GET',
            url: '/products/' + value  + '.js',
            dataType: "json",
            success: function(product) {
              let productTitle = "";
              let productExterior = "";
              let productInterior = "";
              let template;

              if(product.title != "example casket"){
                if(product.title != undefined){
                  productTitle = product.title.split("|")[0];
                  if(product.title.includes("|")){
                    productExterior = product.title.split("|")[1].split("Casket")[0];
                  } else {
                    productExterior = product.title;
                  }
                  if(product.title.includes("with")){
                    if(product.title.split("|")[1].split("Casket")[1] != undefined){
                      productInterior = " // " + product.title.split("|")[1].split("Casket")[1].split("with")[1].split("Interior")[0];
                    }
                  }
                }
                template = 
                `
                <div class = "grid__item thumbnail rv-box-element rv-element">
                  <div class = 'product-wrap'>
                    <a class = 'image__container' href = ${product.url}>
                      <div class = 'image-element__wrap'>
                        <img src = ${product.featured_image} alt = ${product.title} />
                      </div>
                    </a>
                    <div class = "under-image-text">
                      <div class = "info text-align-center">
                        <span class = "product-thumbnail__price price"><span class = "money">${theme.Currency.formatMoney(product.price).replace('.00', '').replace(',', '')}</span></span>
                        <div class = "product-thumbnail__title"> ${productTitle}</div>
                        <p class = "product-thumbnail__color"> ${productExterior} ${productInterior} </p>
                      </div>
                    </div>
                  </div>
                </div>
                `
              }

              if(recentlyViewedContainer.find('.recently-viewed-products-container .thumbnail').length <= 5){
                recentlyViewedContainer.find('.recently-viewed-products-container').append(template);
              }
            }
          });
          return index < limit;
        });
      }
    }
  },

  createSlider: function(el, productsAvailable){

    var products_per_slide = $('.js-rv-slider').data('products-per-slide');
    var products_generated = $('.js-rv-slider').find('.gallery-cell').length;
    var products_available = $('.js-rv-slider').data('products-available');
    var cellAlign = 'left'
    var wrapAround = true;
    var prevNextButtons = true;
    var initialIndex;

    if(products_per_slide >= products_generated) {
      cellAlign = 'center';
      wrapAround = false;
      prevNextButtons = false;
    }

    if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
      initialIndex = 0;
    } else if (products_per_slide == "3" && products_available) {
      initialIndex = 1;
    } else if (products_per_slide == "5" && products_available) {
      initialIndex = 2;
    } else if (products_per_slide == "7" && products_available) {
      initialIndex = 3;
    }

    $('.js-rv-slider').flickity({
      "lazyLoad": 2,
      "imagesLoaded": true,
      "prevNextButtons": prevNextButtons,
      "wrapAround": wrapAround,
      "cellAlign": cellAlign,
      "pageDots": usePageDots,
      "contain": true,
      "freeScroll": true,
      "arrowShape": arrowSize,
      "initialIndex": initialIndex
    });

    $('.js-rv-slider').addClass('slider-initialized');
  }
} 

let smoothScroll = {
  init() {
    document.querySelectorAll('.rte a[href*="#"]').forEach(anchor => {
      const id = anchor.getAttribute('href').split('#')[1];
      anchor.setAttribute('href', '#' + id);

      anchor.addEventListener('click', function (e) {
          e.preventDefault();

          const id = this.getAttribute('href').split('#')[1];
          const scrollTop = document.getElementById(id).getBoundingClientRect().top - 150;

          window.scrollTo(0, scrollTop);
      });
  });
  }
};

// Color schemes dropdown
const relabelColorOptions = () => {
  let colorOptions = document.querySelectorAll(".template-product .color-scheme-dropdown-options");
  
  $(".color-scheme-select").on("change", function() {
    window.location.href = "/products/" + this.value;
  }); 

  colorOptions.forEach(function(el){
    if(window.location.href.includes(el.text)){
      el.selected = true;
    };

    if(el.classList.contains("active")){
      el.innerHTML = el.innerHTML.split("-").join(" ");
    }

    if(el.text != null || el.text != undefined){
      el.text = el.text.split("-").join(" ");
    }
  });
}


let slideUp = {
  init() {
    this.addEventListeners();
  },
  updateVariant(variant_value) {
     this.selectbox.val(variant_value);
     console.log("Select box", this.selectbox[0]);
     this.selectbox[0].dispatchEvent(new Event("change"));
     this.fakeSelect.find('.active').removeClass('active');
     this.fakeSelect.find('[data-value="'+variant_value+'"]').addClass('active');
     this.closeSlider();
  },
  openSlider(slider) {
    $('[data-slide="'+slider+'"]').addClass('active');
    $("html").addClass("disable-scroll");
    $(".complete-overlay").addClass("active");
  },
  closeSlider(slider) {
    $(".slide-up-container").each(function(){
      $(this).removeClass("active");
    })
    $(".complete-overlay").addClass("active");
    $("html").removeClass("disable-scroll");
    $(".complete-overlay").removeClass("active");
    document.body.classList.remove('overflow-hidden');
  },
  addEventListeners () {
    let self = this;
    $(".complete-overlay").on("click", function(){
      self.closeSlider();
    });
    $('.fake-select').on('click', function(){
      let id = $(this).data('id'), 
      slider = $(this).data('option');
      self.openSlider(slider);
      self.selectbox = $('#'+id);
      self.fakeSelect = $(this);
    });
    $('[type="radio"]').on('click', function(){
      let val = $(this).val();
      self.updateVariant(val);
    })
  }
}


let authorPagination = {
  init() {
    if(document.getElementsByTagName('body')[0].classList.contains('template-article')){
      this.addEventListeners();
      this.prevNextButtons();
    }
  },
  prevNextButtons () {
    $("body").on("click", ".pagination-next:not(.disable)", function(e){
      e.preventDefault()
      $('.is-current').parent('li').next().find('.pagination-link').click()
    })
    $("body").on("click", ".pagination-previous:not(.disable)", function(e){
      e.preventDefault()
      $('.is-current').parent('li').prev().find('.pagination-link').click()
    })
  }, 
  addEventListeners () {
    let doc,
      contents,
      updateContents
      counterFrom = 6,
      counterTo = counterFrom + 6;

      const nextButton = document.querySelector('.pagination-next');
      const previousButton = document.querySelector('.pagination-previous');

    $("body").on("click", ".pagination-link:not(.is-current)", function(e){
      e.preventDefault();
      // Display selected state on button
      document.querySelector('.is-current').classList.remove('is-current');
      this.classList.add('is-current');

      // Which articles should be added from the initial fetch
      counterFrom = this.dataset.from;
      counterTo = this.dataset.to;

      // TODO Review. This looks like it can be improved
      // This should disable and enable the prev and next buttons
      if($(this).parent().is(':last-child')) {
        nextButton.classList.add('disabled');
        previousButton.classList.remove('disabled');
     }
      else if($(this).parent().is(':first-child')) {
        nextButton.classList.remove('disabled');
        previousButton.classList.add('disabled');
     }
     else {
      nextButton.classList.remove('disabled');
      previousButton.classList.remove('disabled') ;
     }

      // If we have already fetched the authors articles, then just update the relevant article cards
      if(doc != undefined){
        updateContents = $(contents).slice(counterFrom, counterTo);
        $('#article-grid').html(updateContents);
        return;
      }

      // If this is first time using pagination, let's grap the articles for this author
      fetch('?section_id=author').then(function(response) {
        // The API call was successful
        return response.text();
      }).then(function(html) {
          // Convert the HTML string into a document object
          var parser = new DOMParser();
          doc = parser.parseFromString(html, 'text/html');

          // Get the authors article cards
          contents = $(doc).find('#article-grid .article-card');
          updateContents = $(contents).slice(counterFrom, counterTo);
        $('#article-grid').html(updateContents)
      })
    });
  }
}

function instantBuy(evt) {
  evt.preventDefault();
    var $ = jQuery;

    let data = {
      items: []
    };

    let formData = new FormData(document.querySelector('.product-form-product-template'));

    data.items.push({
      quantity: 1,
      id: formData.get('id')
    });
    
    let upgradeOptionsContainer = document.querySelector('.product-upgrade-options');
    
    if (upgradeOptionsContainer != null) {
      let upgradeOptions = upgrade_options.getSelectedHandles();

      for (let updateOption of upgradeOptions) {
        data.items.push({
          quantity: 1,
          id: updateOption
        });
      }
    }

    $.ajax({
        url: "/cart/add",
        type: "post",
        contentType: 'application/json',
        data: JSON.stringify(data),
        success: function() {
          // window.location.href = "/checkout";
        },
        error: function(){
        }
    })
}

let upgrade_options = {
  getSelectedHandles() {
    let checkboxes = document.getElementsByName('checkbox__upgrade-options');
    let handles = [];
    let skus = [];

    for (let checkbox of checkboxes) {
      if (checkbox.checked) {
        handles.push(checkbox.id);
        skus.push(checkbox.dataset.sku);
      }
    }

    return handles;
  },
  getSelectedSkus() {
    let checkboxes = document.getElementsByName('checkbox__upgrade-options');
    let skus = [];

    for (let checkbox of checkboxes) {
      if (checkbox.checked) {
        skus.push(checkbox.dataset.sku);
      }
    }

    return skus;
  }
}


// function customerImagesBtnHandler(e) {
//   window.scrollTo(0, document.getElementById('accordion_reviews_click').offsetTop);
//   $('#accordion_reviews_click').attr('open', 'true');
// }

let customerImagesCarousel = {
  section_loaded: false,
  loaded: false,
  images: null,
  currentSlide: 0,
  oldReviews: [1],
  first_run: true,
  stored_items: [],

  init() {
    this.section = document.querySelector('.customer-images-section');
    this.offsetTop = () => $(this.section).offset().top;

    this.initGoToButton();

    if (this.section != null) {
      $(window).scroll(function () {
        // Loads the carousel if the scroll Y pos is greater than or equal to the offset top of the carousel minus 500.
        if ($(window).scrollTop() >= customerImagesCarousel.offsetTop() - 500){
          if (!customerImagesCarousel.section_loaded) {
            customerImagesCarousel.load();

            customerImagesCarousel.section_loaded = true;
          }
        }
      });
    }
  },

  initGoToButton() {
    let btn = document.getElementById('customer_images_button');

    if (btn != null) {
      btn.onclick = () => {
        window.scrollTo(0, this.offsetTop() - 200);
      }
    }
  },

  load() {
    this.carousel = document.getElementById('reviews_carousel');
    this.loader = this.section.querySelector('.loading-spinner');

    this.initLoader();
  
    this.buildCarousel();

    this.getImages().then(function () {
      customerImagesCarousel.update_accordion(); 
    });
  },

  async getImages(page = 1) {
    if (!this.loaded || page != 1) {
      let path = window.location.pathname.split('/');
      path = path[path.length - 1];

      await $.ajax({
        url: 'https://titancasket.mizu.a2hosted.com/titan-judge.php',
        type: 'POST',
        data: { 'product': path, 'page': page },
        success: function success(data) {
          if (page == 1) {
            $('#accordion_reviews').html('');
          }

          let tempDom = $('<div></div>').append($.parseHTML(data));

          customerImagesCarousel.images = tempDom.find('.jdgm-rev__pic-img').parent();
          customerImagesCarousel.iterations = tempDom.find('> div').data().numberOfReviews / 10;

          if (customerImagesCarousel.iterations > page) {
            customerImagesCarousel.getImages(page + 1).then(function () {customerImagesCarousel.update_accordion() });
          } else {
            setTimeout(function() {
              customerImagesCarousel.populateSpareItems();
            }, 1000);
          }
        }
      });

      this.loaded = true;
    }
  },

  buildCarousel() {
    if (this.carousel != null) {
      this.carousel.innerHTML = `
        <div class="gallery" ></div>
      `;

      this.carouselInner = this.carousel.querySelector('.gallery');
    }
  },

  slider: null,
  
  initSlider() {
    this.slider = tns({
      container: ".gallery",
      items: 2,
      slideBy: 1,
      mouseDrag: true,
      speed: 400,
      autoHeight: true,
      nav: false,
      controls: false,
      center: false,
      gutter: 10,
      loop: false,
      edgePadding: 20,
      swipeAngle: 30,
      controlsText: [
        '<svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1842 1L1 13.5L12.1842 26" stroke="#092461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        '<svg width="14" height="27" viewBox="0 0 14 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.47375 26L12.658 13.5L1.47375 1" stroke="#092461" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      ],
      responsive: {
        750: {
          items: 3,
          gutter: 15,
          edgePadding: 0,
          controls: true
        }
      }
    });
  },

  initLoader() {
    if (this.loader != null) {
      setTimeout(() => {
        this.loader.querySelector('.text').innerHTML = 'Still Loading...';
      }, 10000);
    }
  },

  hideLoader() {
    this.section.querySelector('.loading-spinner').classList.add('hide');
  },

  async update_accordion() {
    let itemsToAppend = [];

    if (customerImagesCarousel.images.length > 0) {
      this.hideLoader();

      for (const item of customerImagesCarousel.images) {
        let productUrl = $(item).parents('.jdgm-rev').data('productUrl');
        let productTitle = $(item).parents('.jdgm-rev').data('productTitle').split('|')[0];
        let productColor = $(item).parents('.jdgm-rev').data('productTitle').split('|')[1];

        if (productUrl.length > 0) {
          itemsToAppend.push(`
            <a class="jdgm-rev__pic-link" href="${item.dataset.mfpSrc}" target="_blank"
              aria-label="Link to user picture 1" data-mfp-src="${item.dataset.mfpSrc}">
              <img alt="User picture" src="${item.dataset.mfpSrc.split('w=')[0]}" />
            </a>
            <div class="content">
              <p>${productTitle}</p>
              <p>${productColor}</p>
            </div>
          `);

          this.stored_items.push({
            productUrl: productUrl,
            productTitle: productTitle,
            productColor: productColor,
            productImage: item.dataset.mfpSrc
          });
        }
      }

      if (this.first_run) {
        let placeholderCode = '';

        for (let i = 0; i < 50; i++) {
          placeholderCode += `
            <div class="gallery-cell skeleton">
              <div class="image"></div>
              <div class="content"></div>
            </div>
          `;
        }

        this.carouselInner.innerHTML = placeholderCode;
        this.initSlider();

        if (itemsToAppend.length > 0) {
          this.carouselInner = this.carousel.querySelector('.gallery');
          let children = this.carouselInner.children;
          
          for (const itemToAppend of itemsToAppend) {
            children[this.currentSlide].innerHTML = itemToAppend;
            children[this.currentSlide].classList.remove('skeleton');
            this.currentSlide++;
          }
        }

        $.getStylesheet = function (href) {
          var $d = $.Deferred();
          var $link = $('<link/>', {
            rel: 'stylesheet',
            type: 'text/css',
            href: href
          }).appendTo('head');
          $d.resolve($link);
          return $d.promise();
        };
        $.when($.getStylesheet('https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.css'),
          $.getScript('https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js'))
          .then(function () {
            $('.gallery').magnificPopup({
              delegate: 'a',
              type: 'image',
              gallery: { enabled: true },
              defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="jm-mfp-close">&#215;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading...",
                autoFocusLast: !0
              }
            });
          }, function () {
            console.log('an error occurred somewhere');
          });
        
        this.first_run = false;
      } else {
        if (itemsToAppend.length > 0) {
          let children = this.carouselInner.children;
          
          for (const itemToAppend of itemsToAppend) {
            children[this.currentSlide].innerHTML = itemToAppend;
            children[this.currentSlide].classList.remove('skeleton');
            this.currentSlide++;
          }
        }
      }
    }
  },

  populateSpareItems() {
    if (this.stored_items.length > 0) {
      let remainingItems = this.carouselInner.querySelectorAll('.gallery-cell.skeleton');
  
      if (remainingItems.length > 0) {
        let showCarousel = this.stored_items.length > 3;
  
        if (window.innerWidth <= 750) {
          showCarousel = this.stored_items.length > 2;
        }
  
        let storedItemI = 0;
  
        for (const item of remainingItems) {
          let data = this.stored_items[storedItemI];
  
          if (storedItemI == this.stored_items.length - 1) {
            storedItemI = 0;
          } else {
            storedItemI++;
          }
  
          if (data != null) {
            if (showCarousel) {
              item.innerHTML = `
                <a class="jdgm-rev__pic-link" href="${data.productImage}" target="_blank"
                  aria-label="Link to user picture 1" data-mfp-src="${data.productImage}">
                  <img alt="User picture" src="${data.productImage.split('w=')[0]}" />
                </a>
                <div class="content">
                  <p>${data.productTitle}</p>
                  <p>${data.productColor}</p>
                </div>
              `;
      
              item.classList.remove('skeleton');
            } else {
              item.remove();
            }
          }
        }
  
        if (!showCarousel) {
          this.carousel.querySelector('.tns-controls').style.display = 'none';
          this.carousel.classList.add('disabled');
        }
      }
    } else {
      this.hideLoader();
      this.carousel.innerHTML = '<p class="no-images-text"><i>"No customer images have been submitted."</i></p>';
    }
  }

}

/* 
    ===== #document_ready_function ==== 
    TODO: Input all actions that has to parse on load here
*/
readyCustom(function () {
    hamburgerHandler();
    showSearchBar();
    faqs.init();
    swatches.init();
    exteriorColors.init()
    recentlyViewed.init();
    smoothScroll.init();
    relabelColorOptions();
    slideUp.init();
    authorPagination.init();
    customerImagesCarousel.init();
});